// extracted by mini-css-extract-plugin
export default {"body":"Postfix_body__pj45l","footer":"Postfix_footer__r4YbK"};